import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Snowfield from './components/snowfield';
import SiteHeader from './components/site-header';
import SiteFooter from './components/site-footer';
import RouteEffects from './components/route-effects';
import Home from './pages/home';
import Feedback from './pages/feedback';
import { Eula, Privacy, Terms } from './pages/legal';
import NotFound from './pages/not-found';

export default function App() {
  return (
    <BrowserRouter>
      <RouteEffects />
      <Snowfield />
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="app">
        <SiteHeader />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/eula" element={<Eula />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <SiteFooter />
      </div>
    </BrowserRouter>
  );
}
